/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceGroupDto } from '../../models/device-group-dto';
import { UpdateDeviceGroupDto } from '../../models/update-device-group-dto';

export interface DeviceGroupControllerUpdate$Params {
  id: string;
  clientWorkspaceId: string;
      body: UpdateDeviceGroupDto
}

export function deviceGroupControllerUpdate(http: HttpClient, rootUrl: string, params: DeviceGroupControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceGroupDto>;
    })
  );
}

deviceGroupControllerUpdate.PATH = '/api/device-group/{clientWorkspaceId}/{id}';
